import React, { ReactNode } from 'react';
import { Card, Flex, Image, Typography } from 'antd';

import { getSrc } from '../../../../../utils/common/getSrc';
import { ShopProps } from '../service/shop.interface';
import { Copy } from '../../../../../shared/ui/Copy';
import { PurifiedHtml } from '../../../../../shared/ui/PurifyHtml';
import { ShopSelector } from './ShopSelector';

type Props = {
    readonly shop: ShopProps;
    readonly loading: boolean;
    readonly actions?: ReactNode;
    readonly readonly?: boolean;
};
export const ShopCard = ({ shop, loading, actions, readonly }: Props) => {
    if (!shop) return;

    return (
        <Card loading={loading} type='inner' style={{ width: '100%' }}>
            <Flex gap={24}>
                <Image
                    preview={false}
                    style={{
                        width: '122px',
                        height: '122px',
                        borderRadius: '8px',
                    }}
                    src={
                        typeof shop?.photo === 'string' &&
                        shop.photo.startsWith('https://')
                            ? shop.photo
                            : getSrc(`/storage/${shop.photo}`)
                    }
                />

                <Flex
                    vertical
                    style={{
                        width: '100%',
                    }}
                >
                    <ShopSelector readonly={readonly} {...shop} />

                    <Typography.Text>
                        <PurifiedHtml dirtyHtml={shop.about} />
                    </Typography.Text>

                    <Flex
                        vertical={false}
                        justify={'space-between'}
                        align={'center'}
                        wrap={'wrap'}
                        style={{
                            marginTop: 'auto',
                        }}
                    >
                        <Flex vertical>
                            <Flex align={'center'} gap={5}>
                                <Typography.Text
                                    style={{
                                        minWidth: 'fit-content',
                                    }}
                                    strong
                                >
                                    Общая ссылка:
                                </Typography.Text>
                                <Copy text={shop.shop_link} />
                            </Flex>

                            <Flex vertical={false} align={'center'} gap={5}>
                                <Typography.Text
                                    style={{
                                        minWidth: 'fit-content',
                                    }}
                                    strong
                                >
                                    Ссылка на магазин:
                                </Typography.Text>
                                <Copy text={shop.shop_inline} />
                            </Flex>
                        </Flex>

                        <div>{actions && actions}</div>
                    </Flex>
                </Flex>
            </Flex>
        </Card>
    );
};
